<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey" title="Billing">
        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import { computed, RenderFunction } from 'vue';

import {
    PuzzlePieceIcon,
    DocumentTextIcon,
    ArrowPathIcon,
} from '@heroicons/vue/24/solid';

import { route } from 'ziggy-js';
import { usePage } from '@inertiajs/vue3';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';

interface ILink {
    title: string;
    key: string;
    icon: RenderFunction;
    url: string;
}

interface DataTableProps {
    tabKey: string;
}

withDefaults(defineProps<DataTableProps>(), {
    tabKey: 'profile',
});

const globalProps = computed(() => usePage<ITopolPageProps>().props);

let tabs = computed((): ILink[] => {
    const links: ILink[] = [];

    if (globalProps.value.user.app_type === null || globalProps.value.user.app_type == 'pro' || globalProps.value.user.app_type == 'both') {
        links.push({
            title: 'PRO subscription',
            key: 'pro',
            icon: ArrowPathIcon,
            url: route('billing.pro-subscriptions.index'),
        });
    }

    if (globalProps.value.team.personal_team && (globalProps.value.user.app_type === null || globalProps.value.user.app_type == 'plugin' || globalProps.value.user.app_type == 'both')) {
        links.push({
            title: 'Plugin subscription',
            key: 'plugin',
            icon: PuzzlePieceIcon,
            url: route('billing.plugin-subscriptions.index'),
        });
    }

    links.push({
        title: 'Invoices',
        key: 'invoices',
        icon: DocumentTextIcon,
        url: route('billing.invoices.index'),
    });

    return links;
});
</script>
